import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Fieldset } from '../../../../shared/components/fieldset/Fieldset';

export const StyledCreditCardFormSection = styled(Fieldset)``;

export const StyledCreditCardFormSectionHeader = styled.legend`
	font-size: 32px;
	color: #000;
	font-weight: 700;
	margin: 0 0 16px 0;
	padding: 0;
`;

export interface ICreditCardFormSectionProps {
	title?: string;
	className?: string;
	children?: ReactNode;
}

export const CreditCardFormSection = ({
	title,
	className,
	children,
}: ICreditCardFormSectionProps) => (
	<StyledCreditCardFormSection className={className}>
		{title && (
			<StyledCreditCardFormSectionHeader>
				{title}
			</StyledCreditCardFormSectionHeader>
		)}
		{children}
	</StyledCreditCardFormSection>
);
